import {
  Box,
  Container,
  Paper,
  Stack,
  Typography,
  Grow,
  Skeleton,
} from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchExchangeRate } from "../../reducers/exchangeRateReducer";

const RateSkeleton = () => (
  <Paper
    elevation={0}
    sx={{
      py: 2.5,
      px: 3,
      bgcolor: (theme) => `${theme.palette.custom.mint}15`,
      borderRadius: 2,
      flex: 1,
      minWidth: 140,
    }}
  >
    <Stack spacing={1}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Skeleton width={120} height={20} />
        <Box>
          <Skeleton width={80} height={24} />
        </Box>
      </Box>
    </Stack>
  </Paper>
);

export const LimitWidget = () => {
  const dispatch = useDispatch();
  const {
    exchangeRate,
    instantExchangeRate,
    campaignApplied,
    oldExchangeRate,
    oldInstantExchangeRate,
    loading,
  } = useSelector((state) => state.exchangeRate);
  useEffect(() => {
    const profile = localStorage.getItem("profile");
    const userId = JSON.parse(profile || "{}").user_id;
    dispatch(fetchExchangeRate({ userId: userId }));
  }, []);

  const commonPaperStyles = {
    py: 2.5,
    px: 3,
    bgcolor: (theme) => `${theme.palette.custom.mint}15`,
    cursor: "pointer",
    transition: "all 0.3s ease",
    borderRadius: 2,
    flex: 1,
    minWidth: 140,
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: (theme) =>
        theme.palette.mode === "dark"
          ? "0 8px 16px rgba(0, 0, 0, 0.4)"
          : "0 8px 16px rgba(0, 0, 0, 0.1)",
      bgcolor: (theme) => `${theme.palette.custom.mint}25`,
    },
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", gap: 2, my: 2 }}>
        <RateSkeleton />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", gap: 2, my: 2 }}>
      <Grow in={true} timeout={600}>
        <Paper elevation={0} sx={commonPaperStyles}>
          <Stack spacing={1}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  color: (theme) =>
                    theme.palette.mode === "dark"
                      ? theme.palette.text.primary
                      : theme.palette.custom.purple,
                  opacity: 0.9,
                }}
              >
                Today's exchange rate:
              </Typography>
              <Box>
                {campaignApplied || "$1 = "}
                {campaignApplied && exchangeRate !== oldExchangeRate && (
                  <Typography
                    variant="caption"
                    sx={{
                      textDecoration: "line-through",
                      color: "text.secondary",
                      display: "inline-block",
                      mr: 1,
                      fontSize: "0.75rem",
                    }}
                  >
                    ₹{oldExchangeRate}
                  </Typography>
                )}
                <Typography
                  variant="body1"
                  fontWeight={600}
                  sx={{
                    color: "brand.main",
                    display: "inline-block",
                    fontSize: "1rem",
                  }}
                >
                  ₹{exchangeRate}
                </Typography>
              </Box>
            </Box>
          </Stack>
        </Paper>
      </Grow>
    </Box>
  );
};
